import React from "react";
import { TodoWrapper } from "../components/todoWrapper";

const TodoPage = () => {
  return (
    <div>
      <TodoWrapper />
    </div>
  );
};

export default TodoPage;
